import React from 'react';
import { styles } from './styles';
import haku_icon from '../../images/Icon-Raw-Black-Transparent.png';
import { Panel, PanelType} from '../../components';
import {BrowserView, MobileView} from "react-device-detect";

export const IntroPanel: React.FC = () => {

    return (
        <>
            <BrowserView>
                <Panel type={PanelType.LIGHT}>
                    <div style={{display:'flex', flexDirection: 'row', width: '100%'}}>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            <div style={{
                                fontSize: '4rem',
                                marginLeft: '75px',
                                marginBottom: '15px',
                                fontFamily: '"Oswald", sans-serif',
                                fontWeight: 500,
                                color: '#1b1b1b',
                                lineHeight: 1.2,
                                width: '100%',
                            }}>
                                Turning bold healthcare ideas into<br/><span style={{color: 'rgb(0, 4, 255)'}}>breakthrough solutions</span>
                            </div>
                            <div style={{
                                marginLeft: '75px',
                                marginBottom: '50px',
                                fontSize: '1.2rem',
                                color: 'rgb(67, 67, 67)',
                                maxWidth: '50vw',
                            }}>
                                From at-home to in-hospital systems, our end-to-end expertise spans market research, engineering, data science, usability, clinical trials, FDA, reimbursement, and manufacturing—all in one place.
                            </div>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                            }}>
                                <div style={{
                                    marginLeft: '75px',
                                    width: '200px',
                                    height: '60px',
                                    borderRadius: '30px',
                                    border: 'none',
                                    backgroundColor: 'rgb(0, 4, 255)',
                                    color: 'white',
                                    fontSize: '1.1rem',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor: 'pointer'
                                }}>
                                    <div>
                                        Learn More
                                    </div>
                                </div>
                                <div style={{
                                    marginLeft: '30px',
                                    width: '198px',
                                    height: '58px',
                                    borderRadius: '30px',
                                    border: '1px solid rgb(41, 41, 41)',
                                    color: 'rgb(41, 41, 41)',
                                    fontSize: '1.1rem',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s, color 0.2s, border 0.2s',
                                }} onClick={() => {
                                    window.location.href = 'mailto:contact@hakutechnology.com';
                                }}>
                                    <div>
                                        Get in Contact
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            paddingLeft: '75px',
                        }}>
                            <img src={haku_icon} width="400px" alt="Haku icon" />
                        </div>
                    </div>
                </Panel>
            </BrowserView>

            <MobileView>
                <Panel type={PanelType.LIGHT} style={{
                    paddingTop: '35px',
                    paddingBottom: '45px',
                }}>
                    <div style={{display:'flex', flexDirection: 'row', width: '100%'}}>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            <div style={{
                                fontSize: '3.5rem',
                                paddingLeft: '15px',
                                paddingRight: '15px',
                                textAlign: 'center',
                                marginBottom: '15px',
                                fontFamily: '"Oswald", sans-serif',
                                fontWeight: 500,
                                color: '#1b1b1b',
                                lineHeight: 1.2,
                            }}>
                                Turning bold<br/>healthcare<br/>ideas into<br/><span style={{color: 'rgb(0, 4, 255)'}}>breakthrough solutions</span>
                            </div>
                            <div style={{
                                paddingLeft: '35px',
                                paddingRight: '35px',
                                marginBottom: '35px',
                                fontSize: '1.2rem',
                                textAlign: 'center',
                                color: 'rgb(67, 67, 67)',
                            }}>
                                From at-home to in-hospital systems, our end-to-end expertise spans engineering, data science, clinical trials, FDA, reimbursement, and manufacturing—all in one place.
                            </div>
                        </div>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                        <div style={{
                            width: '80%',
                            height: '60px',
                            borderRadius: '30px',
                            border: 'none',
                            backgroundColor: 'rgb(0, 4, 255)',
                            color: 'white',
                            fontSize: '1.1rem',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: 'pointer'
                        }}>
                            <div>
                                Learn More
                            </div>
                        </div>
                        <div style={{
                            width: '80%',
                            marginTop: '15px',
                            height: '58px',
                            borderRadius: '30px',
                            border: '1px solid rgb(41, 41, 41)',
                            color: 'rgb(41, 41, 41)',
                            fontSize: '1.1rem',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: 'pointer',
                            transition: 'background-color 0.2s, color 0.2s, border 0.2s',
                        }} onClick={() => {
                            window.location.href = 'mailto:contact@hakutechnology.com';
                        }}>
                            <div>
                                Get in Contact
                            </div>
                        </div>
                    </div>
                </Panel>
            </MobileView>
        </>
    );
};